import { render, staticRenderFns } from "./Template.vue?vue&type=template&id=68e59ccc&scoped=true&"
import script from "./Template.vue?vue&type=script&lang=ts&setup=true&"
export * from "./Template.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./Template.vue?vue&type=style&index=0&id=68e59ccc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e59ccc",
  null
  
)

export default component.exports